import React, { useEffect, useState, useRef } from 'react';
import {
  PhoneOutlined,
  WhatsAppOutlined,
  AppstoreOutlined,
  CaretRightOutlined,
  CaretDownOutlined,
  TagOutlined, // You can choose any other icon you prefer here
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories } from '../../Redux/slice/categorySlice';
import { fetchBrands } from '../../Redux/slice/brandSlice';
import { useNavigate } from 'react-router-dom';

const HelpNavbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categories } = useSelector((state) => state.categories);
  const { brands } = useSelector((state) => state.brands)

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showCategories, setShowCategories] = useState(false);
  const categoryRef = useRef(null);

  useEffect(() => {
    dispatch(fetchCategories());
    dispatch(fetchBrands());
  }, [dispatch]);

  // Close category dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setShowCategories(false);
        setSelectedCategory(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="bg-green-600 py-1 shadow-md">
      <div className="container mx-auto px-2 flex items-center justify-between relative">
        {/* Categories Dropdown - Hidden on Mobile */}
        <div className="relative md:flex hidden" ref={categoryRef}>
          <button
            className="text-white flex items-center gap-2 px-4 py-2 rounded-md bg-green-700 hover:bg-green-900 transition"
            onClick={() => setShowCategories(!showCategories)}
          >
            <AppstoreOutlined />
            All Categories
            <CaretDownOutlined />
          </button>

          {showCategories && (
  <div style={{maxHeight:"650px"}} className="absolute left-0 bg-white text-black w-60 shadow-lg rounded-md mt-12 p-2 border border-gray-200 z-10 max-h-100 overflow-y-auto">
    {/* Category List */}
    {categories
      .filter((category) => category.stockStatus !== 'Products out of stock' && category.categoryName !== 'Products out of stock')
      .map((category) => (
        <div
          key={category.categoryId}
          className={`p-3 cursor-pointer rounded-md flex items-center justify-between transition ${
            selectedCategory === category.categoryId ? 'bg-green-600 text-white' : 'hover:bg-green-500'
          }`}
          onClick={() =>
            setSelectedCategory(
              selectedCategory === category.categoryId ? null : category.categoryId
            )
          }
        >
          {/* Category Icon and Name */}
          <div className="flex items-center gap-2">
            <TagOutlined className="text-green-600" /> 
            <span>{category.categoryName}</span>
          </div>
          <CaretRightOutlined />
        </div>
      ))}
  </div>
)}

{selectedCategory && (
  <div style={{maxHeight:"650px"}} className="absolute left-[15rem] top-12 bg-white text-black w-64 shadow-lg rounded-md p-2 border border-gray-200 z-10 overflow-y-auto" >
    {/* Brand List for Selected Category */}
    {brands
      .filter((brand) => brand.categoryId === selectedCategory)
      .map((brand) => (
        <div
          key={brand.brandId}
          className="p-3 cursor-pointer rounded-md hover:bg-green-600 hover:text-white transition"
          onClick={() => {
            navigate(`/brand/${brand.brandId}`);
            setShowCategories(false);
            setSelectedCategory(null)
          }}
        >
          {brand.brandName}
        </div>
      ))}
  </div>
)}

        </div>

        {/* Help Section (Centered) */}
        <div className="flex flex-col md:flex-row items-center md:space-x-8 space-y-2 md:space-y-0 mx-auto">
          <p className="text-white text-xs md:text-sm font-semibold">Need Help? Contact Us!</p>
          <div className="flex items-center gap-5">
            <p className="text-white text-sm flex items-center">
              <PhoneOutlined className="mr-2" />
              <a href="tel:+233302225651" className="text-white hover:text-gray-200 transition">
                +233302225651
              </a>
            </p>
            <p className="text-white text-sm flex items-center">
              <WhatsAppOutlined className="mr-2" />
              <a
                href="https://wa.me/+233246422338"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-gray-200 transition"
              >
           +233246422338
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpNavbar;
